import { doc, arrayUnion, updateDoc } from "firebase/firestore";
import { db } from "./firestoredb"; // Firestore initialization

// Util function to push influencer ledger entry
export async function pushInfluencerReferBuyLedger({
  coupon,
  name,
  phone,
  city,
  pincode,
  state,
  orderId,
  price,
  productId,
}) {
  const ledgerCollection = "dharmikxinfluencerledger";

  try {
    const timestamp = new Date();

    const ledgerData = {
      address: {
        city,
        pincode,
        state,
      },
      coupon,
      name,
      orderId,
      phone,
      price,
      productId,
      timestamp,
    };

    const docRef = doc(db, ledgerCollection, coupon);
    await updateDoc(docRef,{
            ledger: arrayUnion(ledgerData),
          });

    console.log("Influencer Ledger Updated Successfully");
  } catch (error) {
    console.error("Error pushing influencer ledger data:", error);
  }
}

export default pushInfluencerReferBuyLedger;